import React, { useState } from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import styled from 'styled-components';
import {isMobile } from 'react-device-detect';
import PerpImg from '../assets/perpShift.png';
import NumericInput from 'react-numeric-input';
import {runPerpendicularShift} from '../actions';
import WaitModal from './waitModal';
import TutorialModal from './tutorialModal';

function PerpendicularShiftTool(props) {



  const [distance, setDistance] = useState(0);
  const [pdbA, setpdbA] = useState('');
  const [pdbB, setpdbB] = useState('');

  const [modalIsOpen, setIsOpen] = useState(false);
  const [isTutorialOpen, setTutorialIsShown] = useState(false);

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }


  // function openTutorial(){
  //   setTutorialIsShown(true);
  // }
  //
  function closeTutorial(){
    setTutorialIsShown(false);

  }


  const PostValues = ()=> {
     openModal();
     const {runPerpendicularShift} = props;
     //runHit(ionName, ionsNumber, cubeSize, mergeFile, ()=>closeModal());
     runPerpendicularShift(distance, pdbA, pdbB, ()=>closeModal());

  };

  return (
    <Container>
      <HeaderContainer>
        <Desc>This tool is used for shifting one given biomolecule on a vector that is perpendicular to the vector going through the mass center of the two given biomolecules.</Desc>

      </HeaderContainer>


      <SubContainer>
        <Img src={PerpImg}/>
        <InputContainer>
        <Form>

          <Label>
            Distance (Å):
            <NumericInput onChange={valueAsNumber => setDistance(valueAsNumber)} step={1}  value={distance}/>
          </Label>
          <Label>
            Molecule A (PDB/PQR format):
            <input onChange={event => setpdbA(event.target.files[0])} type="file" name="pdbA" accept=".pdb,pqr" />
          </Label>
          <Label>
            Molecule B (PDB/PQR format):
            <input onChange={event => setpdbB(event.target.files[0])} type="file" name="pdbB" accept=".pdb,pqr" />
          </Label>
        </Form>
          <Button onClick={()=>PostValues()}> Submit </Button>

         </InputContainer>


      </SubContainer>

      <WaitModal modalIsOpen={modalIsOpen} closeModal={()=>closeModal()} />
      <TutorialModal isTutorialOpen={isTutorialOpen} closeTutorial ={ () =>  closeTutorial()} />

    </Container>




  );
}

const Container = styled.div`
  family-font:'Fira Sans';
`;

const SubContainer = styled.div`
  display: flex;
  flex-direction: ${props=> props.isMobile ? "column" : "row"};
  justify-content: space-around;
  align-items:center;
`;

const InputContainer = styled.div`

`;

const Img = styled.img`
	width: 36vw;
  max-width:652px;
`;

const Form = styled.form`
  display:flex;
  flex-direction:column;
`;

const Label = styled.label`
  display:flex;
  flex-direction:column;
  font-size:15px;
`;


const Button = styled.button`
		border: none;
		width: 200px;
		height:50px;
		margin-right:10px;
		color: #fff;
		background-color: #7eb35b;
		font-size: 1.2em;
		transform-style: preserve-3d;
		outline: none;
		cursor: pointer;
		border-radius: 0.27em;
		text-align: center;
		font-family:'Fira Sans';
    border-color: #52c41a;
    box-shadow: 2px 4px 6px rgb(0 0 0 / 30%);
`;


const HeaderContainer = styled.div`
  display:flex;
  width: 100%;
  justify-content:space-between;
  align-items:center;
  font-size:18px;
`;

const Desc = styled.div`
    font-size:22px;
    margin-bottom:20px;
`;


const mapDispatchToProps = dispatch => {

  return bindActionCreators({runPerpendicularShift}, dispatch);

};


export default connect(null,mapDispatchToProps)(PerpendicularShiftTool);



// WEBPACK FOOTER //
// ./src/components/perpendicularShiftTool.js